//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  components: {},
  data() {
    return {};
  },
  computed: {
    count() {
      return this.tableData ? Object.keys(this.tableData).length : 0;
    },
  },
  methods: {
    getRoute(elem) {
      var routeObj = { name: this.route.name, params: {} };
      routeObj.params[this.route.param] = elem[this.route.paramValueSrc];
      return elem ? routeObj : "/";
    },
  },
  props: {
    title: {
      default: "Title",
    },
    description: {
      default: "",
    },
    primaryAction: {
      default: "New",
    },
    headings: {
      default: function () {
        return ["Name", "Status", "Severity", "Current value", "Rule"];
      },
    },
    route: {
      default: () => {
        return {
          name: "adminLessonDetails",
          param: "lessonKey",
          paramValueSrc: "key",
        };
      },
    },
    tableData: {
      default: () => {
        return [
          {
            label: "Label1",
            status: "Normal",
            value: "38.3",
            severity: 1,
            rule: "Moisture > 40",
            route: "route/path",
          },
          {
            label: "Label2",
            status: "Normal",
            value: "38.3",
            severity: 1,
            rule: "Moisture < 30",
            route: "route/path",
          },
          {
            label: "RPM - HI",
            status: "Normal",
            value: "19",
            severity: 1,
            rule: "RPM > 40",
            route: "route/path",
          },
          {
            label: "RPM - LO",
            status: "Active",
            value: "19",
            severity: 1,
            rule: "RPM < 20",
            route: "route/path",
          },
          {
            label: "Loaded weight - HI",
            status: "Normal",
            value: "318",
            severity: 1,
            rule: "Weight > 320",
            route: "route/path",
          },
          {
            label: "Loaded weight - LO",
            status: "Normal",
            value: "318",
            severity: 1,
            rule: "Weight < 50",
            route: "route/path",
          },
        ];
      },
    },
  },
};
